import { useState, useEffect } from 'react';
import CountUp from 'react-countup';
import { Button } from 'react-bootstrap';

function CounterItem({ end, suffix, label, delay, isClient }) {
  return (
    <div
      className="text-center transition-opacity duration-500 ease-in-out"
      style={{ transitionDelay: `${delay}s` }}
    >
      <h2 className="text-4xl font-bold mb-2" style={{ background: 'linear-gradient(135deg, rgba(65,85,255,1) 92%, rgba(255,255,255,0.3) 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
        {isClient ? <CountUp end={end} /> : <span>{end}</span>}
        <strong className="ml-1">{suffix}</strong>
      </h2>
      <p className="text-gray-600">{label}</p>
    </div>
  );
}

export default function Hero() {
  const [isClient, setIsClient] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsClient(true);
    console.log("Hero Component Rendered"); // Debugging Log
    
    // Check if the device is mobile based on screen width
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 640); // 640px is the 'sm' breakpoint
    };
    
    // Set initial value
    checkIsMobile();
    
    // Add event listener for window resize
    window.addEventListener('resize', checkIsMobile);
    
    // Clean up event listener
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  return (
    <section className="relative min-h-screen w-full bg-[#ffffff] overflow-hidden flex flex-col justify-between">
 
      <div className="absolute inset-0 w-full h-full">
       
          <div
           
            className="absolute h-full w-[5%] bg-[#ffffff]"
            
          />
      </div>

     {/* Main content */}
    <div className="relative z-[5] flex flex-col lg:flex-row items-center px-1 py-10 pt-20 md:pt-10 max-w-8xl  mt-auto mb-auto lg:gap-6">
      
      {/* Text column - Appears first on mobile */}
      <div className="flex-1 lg:pr-12 text-center lg:text-left mb-12 lg:mb-0 lg:order-1 max-w-full px-4 sm:px-8">
        <h1 className="text-4xl md:text-7xl lg:text-7xl font-bold leading-[1.1] tracking-tight text-black mb-2">
          Futeur AI
          <br />
        </h1>

        <p className="mb-10 text-lg font-semibold text-gray-600 max-w-xl mx-auto lg:mx-0">
          The Credit Karma for small businesses.
        </p>
        <p className="mb-4 text-lg font-semibold text-gray-600 max-w-xl mx-auto lg:mx-0">
          Get free business credit reports, track your score, and dispute inaccuracies—all in one platform. Unlock approvals for loans, credit cards, and tradelines with real-time data.
        </p>
        <p className="mb-4 text-lg font-semibold text-gray-600 max-w-xl mx-auto lg:mx-0">
          Know your business credit. Build it. Use it.
        </p>

        {/* Buttons */}
        <div className="mt-10 flex flex-col sm:flex-row gap-4 mx-auto justify-center lg:justify-start lg:mx-0 max-w-xl">
          <Button
            variant="dark"
            className="px-10 py-4 w-full sm:w-auto"
            href="https://apps.apple.com/us/app/futeurcred/id6736497241"
            target="_blank"
            rel="noreferrer"
          > 
            {isMobile ? 'Download for iOS' : 'Download for MacOS'}
          </Button>
        
          <Button
            variant="outline-dark"
            className="px-10 py-4 w-full sm:w-auto"
            href="https://app.futeur.ai/signup"
            target="_blank"
            rel="noreferrer"
          >
            Get Your Free Report Now
          </Button>
        </div>
      </div>
      
      {/* Video column - Appears second on mobile, right on desktop */}
      <div className="flex-1 lg:order-2 relative w-full">
        <div className="relative w-full h-[60vh] sm:h-[70vh] lg:h-[70vh] rounded-lg overflow-hidden">
          <video 
            autoPlay 
            loop 
            muted 
            playsInline
            className="w-full h-full object-cover"
            src="/animate2.mp4"
          >
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </div>

      {/* Counter Section - Now at the bottom */}
      <div className="w-full py-12 bg-white bg-opacity-80 backdrop-blur-sm relative z-[5]">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 text-black max-w-6xl mx-auto">
            <CounterItem
              end={34}
              decimals={1}
              suffix="M+"
              label="Businesses Supported"
              delay={0}
              isClient={isClient}
            />
            <CounterItem
              end={61}
              suffix="M+"
              label="Jobs Supported"
              delay={0.2}
              isClient={isClient}
            />
            <CounterItem
              end={59}
              suffix="M+"
              label="Businesses Supported (2029)"
              delay={0.3}
              isClient={isClient}
            />
            <CounterItem
              end={105}
              suffix="M+"
              label="Jobs Supported (2029)"
              delay={0.4}
              isClient={isClient}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

